<!--
 * @Description: 指定试卷 详情
 * @Author: PF
 * @Date: 2023-09-13 09:59:13
 * @LastEditors: PF
 * @LastEditTime: 2023-09-19 15:32:38
-->
<template>
  <div class="zaixiankaoshi-page">
    <el-container class="pl0 pr0 hp100">
      <el-main class="pl10 pr10 pb0">
        <div v-for="(stItem, stInd) in stData" :key="stInd">
          <p style="font-weight: bold;margin-bottom: 5px;">{{ stItem.th }}、<span v-for="(item, index) in zytxData.list" :key="index"><span v-if="stItem.txid===item.id" style="font-weight: bold;">{{ item.name }}</span></span>题</p>
          <div v-for="(item, index) in stItem.data" :key="index" :id="'' + stInd + index">
            <!-- 试题正文 -->
            <div class="zheng-wen">
              <span>{{ index +1 }}、</span>
              <p style="white-space: pre-wrap; text-indent:0;" v-html="item.stzw"></p>
              <span class="fen-zhi ml5">({{ item.jyksdf }}分)</span>
            </div>
            <el-divider border-style="dotted" />
            <!-- 判断 -->
            <div v-if="item.txid === zytxData.panDuan">
              <div class="da-an">
                <span class="title">答案：</span>
                <span v-if="item.da === true">对</span>
                <span v-if="item.da === false">错</span>
              </div>
            </div>
            <!-- 单选 -->
            <div v-else-if="item.txid === zytxData.danXuan">
              <div class="xuan-xiang">
                <span>试题选项：</span>
                <ul>
                  <li v-for="(xxItem, xxInd) in item.listXztXx" :key="xxInd">
                    <span class="mr5">{{xxItem.xxbh}}.</span> <p style="white-space: pre-wrap; text-indent:0;" v-html="xxItem.xxnr"></p>
                  </li>
                </ul>
              </div>
            <el-divider border-style="dotted" />
              <div class="da-an">
                <span class="title">答案：</span>
                <span>{{ item.da }}</span>
              </div>
            </div>
            <!-- 多选 -->
            <div v-else-if="item.txid === zytxData.duoXuan">
              <div class="xuan-xiang">
                <span>试题选项：</span>
                <ul>
                  <li v-for="(xxItem, xxInd) in item.listXztXx" :key="xxInd">
                    <span class="mr5">{{xxItem.xxbh}}.</span> <p style="white-space: pre-wrap; text-indent:0;" v-html="xxItem.xxnr"></p>
                  </li>
                </ul>
              </div>
            <el-divider border-style="dotted" />
              <div class="da-an">
                <span class="title">答案：</span>
                <span>{{ item.da }}</span>
              </div>
            </div>
            <!-- 填空 -->
            <div v-else-if="item.txid === zytxData.tianKong">
              <div class="da-an">
                <span class="title">答案：</span>
                <ul>
                  <li v-for="(xxItem, xxInd) in item.pdtckda" :key="xxInd">
                    <span class="mr5">{{xxItem.xxbh}}.</span> <p style="white-space: pre-wrap; text-indent:0;" v-html="xxItem.xxnr"></p>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 其他 -->
            <div v-else>
              <div class="da-an">
                <span class="title">答案：</span>
                <ul>
                  <li>
                    <p style="white-space: pre-wrap; text-indent:0;" v-html="item.da"></p>
                  </li>
                </ul>
              </div>
            </div>
            <div class="da-an"><span class="title">难度：</span>{{item.scnd}}</div>
            <div class="da-an"><span class="title">解析：</span><p v-if="item.jx" style="width: calc(100% - 70px);white-space: pre-wrap; text-indent:0;" v-html="item.jx.jx"></p></div>
            <div class="da-an"><span class="title">评分标准：</span><p v-if="item.pfbz" style="width: calc(100% - 70px);white-space: pre-wrap; text-indent:0;" v-html="item.pfbz.pfbz"></p></div>
            <div class="da-an"><span class="title">考试要求：</span><p v-if="item.ksyq" style="width: calc(100% - 70px);white-space: pre-wrap; text-indent:0;" v-html="item.ksyq.ksyq"></p></div>
            <el-divider />
          </div>
        </div>
      </el-main>
      <el-aside class="pl10 pr10" width="250px">
        <div class="dao-hang">
          <div v-for="(item,index) in stData" :key="index">
            <p style="font-weight: bold;margin-bottom: 5px;">{{ item.th }}、<span v-for="(val, ind) in zytxData.list" :key="ind"><span v-if="item.txid===val.id" style="font-weight: bold;">{{ val.name }}</span></span>题</p>
            <el-link v-for="(val,v) in item.data" :key="v" :underline="false" :href="'#' + index + v" :style="val.sfyd ? 'background-color: #409EFF;color: #FFF': 'background-color: #e9e9eb;color: #000'">{{ v + 1 }}</el-link>
          </div>
        </div>
      </el-aside>
    </el-container>
  </div>
</template>

<script setup>
import { defineProps, ref, watch } from 'vue'
import { loadSelect } from '@/api/common.js'
import { toChinesNum } from '@/utils/index.js'
import { getTiXing } from '@/utils/zidianmeiju'

const props = defineProps({ row: { type: Array, required: true } })

const stData = ref([])
const zytxData = ref({ list: [] })

const sjlxData = ref({ list: [] })
watch(
  () => props.row,
  () => {
    if (props.row.length) {
      zytxData.value = getTiXing()
      loadSelect({ url: '/api/v2/jiaowu/kaowukaoshijihua/shijuanleibie', data: sjlxData })
      const map = {}
      stData.value = []
      for (let i = 0; i < props.row.length; i++) {
        const ai = props.row[i]
        if (!map[ai.txid]) { // txid 依赖字段 可自行更改
          stData.value.push({
            txid: ai.txid, // txid 依赖字段 可自行更改
            th: null,
            data: [ai]
          })
          map[ai.txid] = ai
        } else {
          for (let j = 0; j < stData.value.length; j++) {
            const dj = stData.value[j]
            if (dj.txid === ai.txid) { // txid 依赖字段 可自行更改
              dj.data.push(ai)
              break
            }
          }
        }
      }
      stData.value.map((item, index) => {
        item.th = toChinesNum(index + 1)
        item.data = item.data.map(val => {
          val.listXztXx = val.listXztXx.sort(function compareFunction (param1, param2) { return param1.xxbh.localeCompare(param2.xxbh, 'zh') })
          return val
        })
        return item
      })
    }
  },
  { deep: true, immediate: true }
)

</script>
<style lang="less" scoped>
.zaixiankaoshi-page {
  height: 100%;
  .el-aside {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .shi-jian {
    font-size: 18px;
    margin-bottom: 10px;
    span {
      color: #409EFF;
      margin-left: 5px;
    }
  }
  .dao-hang {
    width: 100%;
    padding: 10px 20px;
    overflow: auto;
    display: flex;
    align-content: flex-start;
    flex-direction: column;
    background-color: #f9f9f9;
    border-radius: 10px;
    :deep(.el-link) {
      margin: 4px;
      width: 30px;
      height: 30px;
      border-radius: 4px;
      background-color: #e9e9eb;
      box-shadow: 1px 1px 0px 0 rgb(0 0 0 / 30%)
    }
  }
  .zheng-wen {
    display: flex;
  }
  .xuan-xiang {
    display: flex;
    margin-left: 20px;
    ul {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      li {
        display: flex;
        align-items: center;
      }
    }
  }
  .da-an {
    display: flex;
    margin-left: 20px;
    .title {}
  }
}
</style>
